import React from 'react';
import { useSlideIndex } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;
const LinkedInIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect x="2" y="9" width="4" height="12" /><circle cx="4" cy="4" r="2" /></svg>;

const TEAM = [
    {
        role: 'Founder & CEO', name: 'Mark Bernstein', linkedin: 'https://www.linkedin.com/in/markbernstein',
        img: require('../../../../images/landing-pages/about-us/mark-picture.png'), photoBg: '#EEF1FF', cardDark: true,
        bullets: [
            'Chartered Accountant, 30+ years across startups, VC-backed and LSE/AIM-listed companies',
            '4 IPOs including two unicorns — GeoCities sold to Yahoo! for $4.3bn',
            '25 M&A transactions as founder, CFO, chair and NED',
            'Wearable Technologies sold to Blackline Safety Corp (TSX) 2021',
        ],
    },
    {
        role: 'Chief Technology Officer', name: 'Jon Bradshaw', linkedin: 'https://www.linkedin.com/in/jmbradshaw',
        img: require('../../../../images/landing-pages/about-us/jonpicture.png'), photoBg: '#EEF1FF', cardDark: false,
        bullets: [
            'Fractional and full-time CTO across B2B SaaS, health, pharma, adtech, and web3',
            "Named inventor on multiple patents; built the world's first online Fantasy Football game",
            'VP Engineering, Elliptic (crypto AML); CTO, FITFILE (real-world health evidence)',
        ],
    },
];

const renderPersonSlide = (p, key, isClone = false) => (
    <div className="lp-about-slide" key={key} aria-hidden={isClone || undefined}>
        <div className="lp-about-person-card">
            <div className="copy">
                <div className="role">{p.role}</div>
                <h3>{p.name}</h3>
                <a className="li" href={p.linkedin} target="_blank" rel="noopener noreferrer"><LinkedInIcon />LinkedIn</a>
                <div className="bullets">
                    {p.bullets.map((b, j) => <div key={j}><span>→</span><span>{b}</span></div>)}
                </div>
            </div>
            <div className="photo" style={{ background: p.photoBg }}>
                <img src={p.img} alt={p.name} />
                <div className={`tag ${p.cardDark ? 'tag--dark' : 'tag--light'}`}>
                    <div className="role">{p.role}</div>
                    <div className="name">{p.name}</div>
                </div>
            </div>
        </div>
    </div>
);

const AboutTeamSlider = () => {
    const { index, trackStyle, next, prev, goTo, pause, resume } = useSlideIndex(TEAM.length, { autoplayMs: 4500 });

    return (
        <section id="team" className="lp-about-team">
            <div className="lp-container">
                <div className="lp-badge" data-lp-reveal><span />The team</div>
                <div className="lp-sec-head" style={{ margin: '0 0 48px' }}>
                    <div>
                        <h2 className="lp-h2" data-lp-reveal>Meet the people behind Diligentsia.</h2>
                        <p className="lp-sub" data-lp-reveal data-lp-delay="60">Operators, investors, and technologists who've done it before.</p>
                    </div>
                    <div className="lp-arrows">
                        <button className="lp-arrow" aria-label="Previous" onClick={prev}><ChevronL /></button>
                        <button className="lp-arrow" aria-label="Next" onClick={next}><ChevronR /></button>
                    </div>
                </div>
            </div>

            <div className="lp-about-slide-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-about-slide-track" style={trackStyle}>
                    {TEAM.map((p, i) => renderPersonSlide(p, i))}
                    {/* Clone of the first slide — the forward wrap animates onto it, then snaps back */}
                    {renderPersonSlide(TEAM[0], 'clone-first', true)}
                </div>
            </div>

            <div className="lp-container lp-about-slide-foot">
                <span>{index + 1} / {TEAM.length}</span>
                <div className="lp-dots">
                    {TEAM.map((_, i) => (
                        <button key={i} className={`lp-dot ${i === index ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AboutTeamSlider;
